import { useRecoilValue } from 'recoil'
import maintenanceBlankSchemasAtom from '../MaintenanceBlanks/maintenanceBlankSchemas.atom.ts'
import { useMemo } from 'react'
import { IMaintenanceBlankSchema } from '../maintenance.types.ts'

const useMaintenanceBlankSchema = (id: IMaintenanceBlankSchema['id']) => {
  const schemas = useRecoilValue(maintenanceBlankSchemasAtom).items

  return useMemo(() => {
    return schemas.find((s) => s.id === id)
  }, [id, schemas])
}

export default useMaintenanceBlankSchema
